import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen, faHome, faReceipt, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { Badge, Nav } from "@themesberg/react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { Routes } from "../routes";
import { getCartCount, subscribeToCartUpdates } from "../utils/cartStorage";

const navItems = [
  { path: Routes.Products.path, icon: faHome, label: "Home" },
  { path: Routes.MyOrders.path, icon: faReceipt, label: "Orders" },
  { path: Routes.Cart.path, icon: faShoppingCart, label: "Cart" }
];

export default () => {
  const location = useLocation();
  const [cartCount, setCartCount] = useState(getCartCount());

  useEffect(() => {
    const syncCartCount = () => setCartCount(getCartCount());
    return subscribeToCartUpdates(syncCartCount);
  }, []);

  const isActivePath = (path) => {
    if (path === Routes.Products.path) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Nav className="vendor-bottom-nav d-lg-none">
      {navItems.map((item) => (
        <Nav.Item key={item.path} as="li">
          <Nav.Link
            as={Link}
            to={item.path}
            className={`vendor-bottom-nav-item ${isActivePath(item.path) ? "active" : ""}`}
          >
            <div className="vendor-bottom-nav-icon-wrapper">
              <FontAwesomeIcon icon={item.icon} />
              {item.path === Routes.Cart.path && cartCount > 0 && (
                <Badge pill bg="danger" className="vendor-bottom-nav-badge">
                  {cartCount > 99 ? "99+" : cartCount}
                </Badge>
              )}
            </div>
            <span className="vendor-bottom-nav-label">{item.label}</span>
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};